import { createContext, useContext } from "react";

const ClerkAvailableContext = createContext(false);

export const ClerkAvailableProvider = ClerkAvailableContext.Provider;

export function useClerkAvailable(): boolean {
  return useContext(ClerkAvailableContext);
}
